import script from "./NumericQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./NumericQuestion.vue?vue&type=script&setup=true&lang=js"

import "./NumericQuestion.vue?vue&type=style&index=0&id=47d946df&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d946df"]])

export default __exports__